<core-snack-bar
  icon="refresh"
  [dismissable]="false"
  [updating]="true">
  <span>{{ 'BC.SNACKBAR.UPDATE.MESSAGE' | translate }}</span>
  <br>
  <span [translate]="'BC.SNACKBAR.UPDATE.MESSAGE_COUNTER'" [translateParams]="{ counter: countdown }"></span>
</core-snack-bar>
